import React, { useState, useRef, useEffect } from 'react';
import './VisionSection.css';
import VerticalDecoration from '../components/VerticalDecoration/VerticalDecoration';

// Importez vos images ici
import appsImage from '../assets/images/vision1.png';
import entertainmentImage from '../assets/images/controlle.png';
import photosImage from '../assets/images/avenir.jpg';
import connectionImage from '../assets/images/dashboard.png';

const features = [
  {
    id: 'Rendement Garanti',
    title: 'Rendement Garanti',
    subtitle: "L'Ère du Rendement Garanti.",
    heading: "L'Ère du Rendement Garanti.",
    description: "Finis les risques d'une inspection humaine incomplète. Grâce à une surveillance constante et à un diagnostic prédictif, élimine les pertes invisibles. Nous garantissons une augmentation quantifiée et mesurable de votre productivité.",
    category: 'Rendement Garanti',
    image: appsImage
  },
  {
    id: 'Zéro Intervention',
    title: 'Zéro Intervention',
    subtitle: 'Zéro Contact. Le Pilote Hors Serre.',
    heading: 'Zéro Contact. Le Pilote Hors Serre..',
    description: "Le robot redéfinit votre rôle. Vous pilotez l'intégralité de la surveillance et du diagnostic depuis votre bureau. Ceci permet non seulement d'éviter les erreurs humaines, mais aussi de supprimer la procédure longue et coûteuse d'accès, garantissant un environnement stérile et une efficacité opérationnelle maximale.",
    category: 'Zéro Intervention',
    image: entertainmentImage
  },
  {
    id: 'Durabilité',
    title: "Durabilité",
    subtitle: "Cultiver l'Avenir. Moins d'impact, plus de valeur.",
    heading: "Cultiver l'Avenir. Moins d'impact, plus de valeur.",
    description: "En identifiant précisément les zones de stress, le robot permet une allocation des ressources (eau, engrais, traitements) chirurgicale. Réduisez drastiquement votre empreinte environnementale et vos coûts opérationnels, tout en maximisant la santé de vos cultures.",
    category: 'Durabilité',
    image: photosImage
  },
  {
    id: 'Fermier Augmenté',
    title: 'Fermier Augmenté',
    subtitle: "Le Pouvoir de la Décision. Le Fermier Augmenté.",
    heading: "Le Pouvoir de la Décision. Le Fermier Augmenté.",
    description:  "Nous transformons les agriculteurs en experts en données. Le robot délivre des informations claires et exploitables directement sur votre tableau de bord, vous libérant des tâches répétitives pour vous concentrer sur la stratégie et la croissance future de votre exploitation.",
    category: 'Fermier Augmenté',
    image: connectionImage
  }
];

const VisionSection = () => {
  const [activeFeature, setActiveFeature] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handlePrevious = () => {
    setActiveFeature((prev) => (prev > 0 ? prev - 1 : features.length - 1));
  };

  const handleNext = () => {
    setActiveFeature((prev) => (prev < features.length - 1 ? prev + 1 : 0));
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!isMobile) return;
    
    const swipeThreshold = 50;
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        handleNext();
      } else {
        handlePrevious();
      }
    }
  };

  return (
    <section className="vision-section" id="visionos">
      <div className="vision-container">
        <VerticalDecoration text={features[activeFeature].category} />

        <div 
          className="vision-content"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="vision-text">
            <h2>{features[activeFeature].heading}</h2>
            <p>{features[activeFeature].description}</p>
          </div>

          <div className="vision-image">
            <div className="vision-image-wrapper">
              <img 
                src={features[activeFeature].image}
                alt={features[activeFeature].heading}
                className="vision-img"
                key={activeFeature}
              />
            </div>
          </div>
        </div>

        {/* Pagination mobile */}
        {isMobile && (
          <div className="mobile-pagination">
            {features.map((_, index) => (
              <button
                key={index}
                className={`pagination-dot ${activeFeature === index ? 'active' : ''}`}
                onClick={() => setActiveFeature(index)}
                aria-label={`Go to feature ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Navigation desktop/tablet */}
        <div className="vision-nav">
          <button 
            className="nav-arrow nav-arrow-left" 
            onClick={handlePrevious}
            aria-label="Previous feature"
          >
            ←
          </button>

          {features.map((feature, index) => (
            <button
              key={feature.id}
              className={`vision-nav-item ${activeFeature === index ? 'active' : ''}`}
              onClick={() => setActiveFeature(index)}
            >
              <span className="nav-title">{feature.title}</span>
              <span className="nav-subtitle">{feature.subtitle}</span>
            </button>
          ))}

          <button 
            className="nav-arrow nav-arrow-right" 
            onClick={handleNext}
            aria-label="Next feature"
          >
            →
          </button>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;